import {loadModules} from "esri-loader";
import {arcgisConfig} from "@/config";

const arcgisModules = loadModules([
    // Tasks
    "esri/tasks/QueryTask",
    "esri/tasks/support/Query",
    "esri/tasks/support/RelationshipQuery",
    // Symbols
    "esri/Graphic",
    "esri/symbols/SimpleMarkerSymbol",
    "esri/symbols/PictureMarkerSymbol"
], arcgisConfig.loaderOptions).then( ([
      QueryTask,
      Query,
      RelationshipQuery,
      Graphic,
      SimpleMarkerSymbol,
      PictureMarkerSymbol,
  ]) => {
    return {
        SimpleMarkerSymbol,
        Graphic,
        RelationshipQuery,
        Query,
        QueryTask,
    };
});

export async function getFeatures({serviceUrl, where, returnGeometry, outFields, orderByFields, returnDistinctValues, outStatistics, options,withRelationship=false}){
    const {Query, QueryTask, RelationshipQuery} = await arcgisModules;
    const queryTask = new QueryTask({url: serviceUrl});
    const query = new Query({
        where: where || "1=1",
        returnGeometry,
        outFields: outFields || ['*'],
        returnDistinctValues: returnDistinctValues || false,
        outStatistics: outStatistics || null,
        orderByFields: orderByFields || [],
    });
    options = options || {};
    Object.assign(query, options);
    if (!withRelationship){
        return queryTask.execute(query);
    }else{
        const objectIds = await queryTask.executeForIds(query)
        const relationshipQuery = new RelationshipQuery({
                objectIds: objectIds,
                returnGeometry: true,                    
                relationshipId: 0,
                outFields:['*']
            });
        return queryTask.executeRelationshipQuery(relationshipQuery)
    }
}

export async function getFeaturesExtent({serviceUrl, where}){

    const {Query, QueryTask} = await arcgisModules;
    const queryTask = new QueryTask({url: serviceUrl});
    const query = new Query({
        where: where || "1=1",
    });

    return queryTask.executeForExtent(query);

}

export async function addFeatureToView({feature,view}){
    let _symbol = [];
    _symbol.width = 1.5;
    _symbol.color = [255,0,0];
    _symbol.Outcolor = [255,0,0];
    _symbol.Outwidth = 1.5;
        
    const {Graphic} = await arcgisModules;

    switch(feature.geometry.type){
        case "point":
                _symbol.type = "simple-marker";
                _symbol.width = 0;
                _symbol.color =[255,0,0,0.10];
                break;
        case "polyline":
                _symbol.type = "simple-line";
                break;									
        case "polygon":
                _symbol.type = "simple-fill";
                break;
    };
    const oSymbol = {
            type: _symbol.type,
            /*color:_symbol.color,
            width: _symbol.width,*/
            outline: {
                    color: _symbol.Outcolor,
                    width: _symbol.Outwidth
                }
    };
    // Add the geometry and symbol to a new graphic
    const oGraphic = new Graphic({ 
                        geometry: feature.geometry,
                        symbol: oSymbol
                     });
    //--Agregamos el Grafico al Mapa                 
    view.graphics.add(oGraphic);                 
}
export async function addSvgToView({feature,view,oSize,oWidth}){       
    const {Graphic} = await arcgisModules;
    const oSymbol = {
        type: "simple-marker",
        size: oSize,
        color: [0, 0, 0, 0],
        outline: {
            color: [255, 0, 0],
            width: oWidth
        }
    };

    // Add the geometry and symbol to a new graphic
    const oGraphic = new Graphic({ 
                        geometry: feature.geometry,
                        symbol: oSymbol
                     });
    //--Agregamos el Grafico al Mapa                 
    view.graphics.add(oGraphic);

}

export function letraCapital(strCadena){
    strCadena = strCadena.toLocaleLowerCase();
    const cadenaRetorno = strCadena.replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function($1){
                            return $1.toUpperCase(); 
                          });
   return cadenaRetorno;
}
